
import webApi from './webApi'



export const getAllTenants = async()=>{

    return await webApi.httpGet('tenants', )

};


export const doLogin = async(user)=>{

    return await webApi.httpPost('auth/login', user)

};


